export const topChart = () => {
  $(function () {
    const barChartDuration = 2000; // ms

    function animateBarChart(element) {
      const chart = $(element);
      if (!chart.is(".p-top-data__bar-graph")) return;

      const categories = chart.find(".p-top-data__bar-graph-item");
      const duration = barChartDuration / categories.length;

      // Find max value
      let values = [];
      let maxValue = 0;

      for (let i = 0; i < categories.length; i++) {
        values.push($(categories[i]).data("value"));
        maxValue = Math.max(maxValue, values[i]);
      }

      // Animate each category
      let heights = [];
      let heightsP = [];

      for (let i = 0; i < categories.length; i++) {
        setTimeout(
          function (i) {
            let category = $(categories[i]);
            let height = (100 * values[i]) / maxValue;
            let top = category.find(".p-top-data__bar-graph-top");
            let bar = category.find(".p-top-data__bar-graph-bar");
            let lastHeightP = heightsP.length > 0 ? heightsP[i - 1] : 0;
            heightsP.push(height); // Keep height value to use latter

            top.animate({ bottom: height + "%" }, duration);
            bar.animate({ height: height + "%" }, duration, function () {
              // Show connect line
              let bar = $(this);
              let height = bar.height();
              let lastHeight = heights.length > 0 ? heights[i - 1] : 0;
              heights.push(height); // Keep height value to use latter
              let category = bar.closest(".p-top-data__bar-graph-item");
            });
          },
          i * duration,
          i
        );
      }
    }

    $(".p-top-data__bar-graph").on("inview", function (event, isInView) {
      if (isInView) {
        animateBarChart(this);
      }
    });
  });
};
